import React, { Component } from "react";
import SharedViewProps from "../../../models/types/SharedViewProps";
import { Switch, Route, Redirect } from "react-router";
import IntroductionView from "./modules/Introduction/IntroductionView";
import WorkerInfoView from "./modules/WorkerInfo/WorkerInfoView";
import InjuryInfoView from "./modules/InjuryInfo/InjuryInfoView";
import BillingInfoView from "./modules/BillingInfo/BillingInfoView";
import PaymentView from "./modules/Payment/PaymentView";
import ConfirmationView from "./modules/Confirmation/ConfirmationView";

export default class OneShotRequestView extends Component<SharedViewProps> {

    render() {
        return (
            <Switch>
                <Route path={`/:language/one-shot/introduction`} render={routeProps => <IntroductionView routeProps={routeProps} />} />
                <Route path={`/:language/one-shot/worker-info`} render={routeProps => <WorkerInfoView routeProps={routeProps} />} />
                <Route path={`/:language/one-shot/injury-info`} render={routeProps => <InjuryInfoView routeProps={routeProps} /> } />
                <Route path={`/:language/one-shot/billing-info`} render={routeProps => <BillingInfoView routeProps={routeProps} /> } />
                <Route path={`/:language/one-shot/payment`} render={routeProps => <PaymentView routeProps={routeProps} />} />
                <Route path={`/:language/one-shot/confirmation`} render={routeProps =>  <ConfirmationView routeProps={routeProps} />} />
                <Route path={`/:language/one-shot`} render={() => <Redirect to={`/${this.props.routeProps.match.params.language}/one-shot/introduction`} />} />
            </Switch>
        );
    }
}